"use client";

import Fieldset from "@client/components/lead-form/components/fieldset";
import {
	faCar,
	faHome,
	faMoneyBillWave,
	faPiggyBank,
	faUmbrellaBeach,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { setUserInteractionDataAttribute } from "@shared/constants";
import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import { Tile } from "@ui/js/components/tiles/tile";
import { Field, useFormikContext } from "formik";

const INPUT_ID_AND_LABEL_HTMLFOR = "financial-goal";
const FIELD_NAME_SELECTOR = kebabToCamelCase(INPUT_ID_AND_LABEL_HTMLFOR);
export default function financialGoal() {
	const { setFieldValue } = useFormikContext();
	const handleClick = (e: any) => {
		setFieldValue(FIELD_NAME_SELECTOR, e.currentTarget.value);
	};
	return (
		<Fieldset legend="What would you do with extra monthly savings?">
			<Field
				type="hidden"
				name={FIELD_NAME_SELECTOR}
				id={INPUT_ID_AND_LABEL_HTMLFOR}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__pay_off_debt_faster`,
				)}
				iconLeft={<FontAwesomeIcon icon={faMoneyBillWave} />}
				label="Pay off my debt faster"
				value="pay_off_debt_faster"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__purchase_a_home`,
				)}
				iconLeft={<FontAwesomeIcon icon={faHome} />}
				label="Purchase a home"
				value="purchase_a_home"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__buy_a_vehicle`,
				)}
				iconLeft={<FontAwesomeIcon icon={faCar} />}
				label="Buy a vehicle"
				value="buy_a_vehicle"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__save_or_invest`,
				)}
				iconLeft={
					<FontAwesomeIcon icon={faPiggyBank} className="text-primary" />
				}
				label="Save or invest"
				value="save_or_invest"
				onClick={handleClick}
			/>
			<Tile
				{...setUserInteractionDataAttribute(
					`lead-form__${INPUT_ID_AND_LABEL_HTMLFOR}__flexible_spending`,
				)}
				iconLeft={
					<FontAwesomeIcon icon={faUmbrellaBeach} className="text-primary" />
				}
				label="Enjoy flexible spending"
				value="flexible_spending"
				onClick={handleClick}
			/>
		</Fieldset>
	);
}
